/**
 * This relies heavily on the logic in acc.productMiterSawing. Some logic is replaced by dkg specific logic, but e.g.
 * opening/reopening the dialog is still mostly handled there.
 */
ACC.dkgProcessing = {
    FIX_CUT_ID: "10",
    bind: function() {
        $(document).on('click', '.dkg-confirm-miter-sawing-data', this.submitFigureCuttingOverlay.bind(this));
        $(document).on('click', '.dkg-confirm-fix-cutting', this.submitFixCuttingOverlay.bind(this));
        $(document).on('click', '.custom-dimension-input-popup_cancel', this.closeFixCuttingOverlay.bind(this));
        $(document).on('click', '.miter-form', this.onFigureVariantChange.bind(this));
        $(document).on('change', '#dkgConservationList', this.changeConservation.bind(this));
    },
    openCustomDimensionOverlay: function(e) {
        var custDimButton = e.currentTarget;
        if (custDimButton.classList.contains('not-active')) {
            return;
        }

		ACC.dkgProcessingValidations.getMaxCustomLengthValue();

        if (custDimButton.getAttribute('data-is-figure-cutting-available')) {
            ACC.productMiterSawing.callMiterSawingColorBox('init');
        } else if (custDimButton.getAttribute('data-is-fixed-cutting-available')) {
            $('.dkg-fixed-cutting-overlay').removeClass('hidden');
            $('.dkg-fixed-cutting-overlay .custom-dimension-wrapper').removeClass('hide');
            $('.dkg-fixed-cutting-overlay .custom-dimension-input-popup').removeClass('hide');
        }
    },
    submitFigureCuttingOverlay: function(e) {
        e.preventDefault();
        var length = $('.custom-dimension-miter-wrapper .input-miter-length').val();
        if ($('#fixedLengthButton.selected').length) {
            // fixed cutting on figure cutting overlay
            if (!ACC.dkgProcessingValidations.figureCuttingLengthValidation()) {
                return;
            }

            ACC.dkgProcessingCustDimButton.markAsFixCut(length); // mark should be always executed before the save is called, otherwise mark will delete the values
            this.saveAddToCartFields(length, ACC.dkgProcessing.FIX_CUT_ID, "", "", "", "");
            this.hideMiterSawingSummary();
        } else if ($('#miterSawingButton.selected').length) {
            // figure cutting on figure cutting overlay
            var isLengthValid = ACC.dkgProcessingValidations.figureCuttingLengthValidation();
            var isCuttingOptionValid = ACC.dkgProcessingValidations.figureCuttingOptionValidation();
            var areCuttingAnglesValid = ACC.dkgProcessingValidations.figureCuttingAnglesValidation();
            if (!isLengthValid || !isCuttingOptionValid || !areCuttingAnglesValid) {
                return;
            }
            var processingId = $('#miterCarousel .miter-form.selected').attr('data-sawing-type');
            var angleA = $('.custom-dimension-miter-wrapper .miter-angle-1 .input-miter-angle').val();
            var angleB = $('.custom-dimension-miter-wrapper .miter-angle-2 .input-miter-angle').val();
            var angleC = $('.custom-dimension-miter-wrapper .miter-angle-3 .input-miter-angle').val();
            var angleD = $('.custom-dimension-miter-wrapper .miter-angle-4 .input-miter-angle').val();
            ACC.dkgProcessingCustDimButton.markAsFigureCut(); // mark should be always executed before the save is called, otherwise mark will delete the values
            this.saveAddToCartFields(length, processingId, angleA, angleB, angleC, angleD);
            this.showMiterSawingSummary(length, processingId, angleA, angleB, angleC, angleD);
        }
        $('.custom-dimension-miter-wrapper').addClass("hide");
        $('.custom-dimension-miter-input-popup').removeClass('open').addClass("hide");
        this.callVariant();
        this.callVariantDetails();
        $.colorbox.close();
        this.hideFavoriteToggle();
    },
    submitFixCuttingOverlay: function(e) {
        // fixed cutting on fixed cutting overlay
        e.preventDefault();
        if (!ACC.dkgProcessingValidations.fixedCuttingLengthValidation()) {
            return;
        }
        var length = $('.fixed-cutting-length-input').val();
        this.saveAddToCartFields(length, ACC.dkgProcessing.FIX_CUT_ID, "", "", "", "");
        this.hideMiterSawingSummary();
        ACC.dkgProcessingCustDimButton.markAsFixCut(length);
        this.callVariant();
        this.callVariantDetails();
        this.closeFixCuttingOverlay(e);
        this.hideFavoriteToggle();
    },
    closeFixCuttingOverlay: function(e) {
        e.preventDefault();
        $('.dkg-fixed-cutting-overlay .custom-dimension-wrapper').addClass('hide');
    },
    /**
     * Hides the sawing summary on the pdp
     */
    hideMiterSawingSummary: function() {
        $('.show-miter-custom-data').addClass('hide');
        $('.show-miter-tolerance').addClass('hide');
        $('.show-miter-angle-2').addClass('hide');
        $('.show-miter-angle-3').addClass('hide');
        $('.show-miter-angle-4').addClass('hide');
    },
    /**
     * Updates and shows the sawing summary on the pdp
     */
    showMiterSawingSummary: function(length, processingId, angleA, angleB, angleC, angleD) {
        this.hideMiterSawingSummary();
        $('.show-miter-custom-data').removeClass('hide');
        $('.show-miter-form-image .value').html($('.miter-form-image').html());
        $('.show-miter-form-name .value').text(processingId);
        $('.show-miter-length .value').text(length);
        $('.show-miter-angle-1 .value').text(angleA + "°");
        if (angleB) {
            $('.show-miter-angle-2').removeClass('hide');
            $('.show-miter-angle-2 .value').text(angleB + "°");
        }
        if (angleC) {
            $('.show-miter-angle-3').removeClass('hide');
            $('.show-miter-angle-3 .value').text(angleC + "°");
        }
        if (angleD) {
            $('.show-miter-angle-4').removeClass('hide');
            $('.show-miter-angle-4 .value').text(angleD + "°");
        }
    },
    saveAddToCartFields: function(length, processingId, angleA, angleB, angleC, angleD) {
        $('#processingLength').val(length);
        $('#processingId').val(processingId);
        $('#processingAngleA').val(angleA);
        $('#processingAngleB').val(angleB);
        $('#processingAngleC').val(angleC);
        $('#processingAngleD').val(angleD);
    },
    changeConservation: function(e) {
        var conservationId = e.currentTarget.value;
        if (conservationId == "0_default") {
            $('#conservationId').val('');
        } else {
            $('#conservationId').val(conservationId);
        }
        quantityChange();
    },
    hideFavoriteToggle: function() {
        $('.favorite-tr').addClass('hide');
    },
    showFavoriteToggle: function() {
        $('.favorite-tr').removeClass('hide');
    },
    onFigureVariantChange: function(e) {
        ACC.dkgProcessingValidations.cleanAllValidationErrors();
    },

    callVariantDetails: function() {
    	var variantCode = $('#variantCode').html();
    	if (!variantCode) {return;}
    	var detailsUrl = $('#productVariants').data('productDetailsUrl');
        $.get(detailsUrl , {
                variant: variantCode,
                processingLength: $("#processingLength").val()
            },
            function (data) {
                var $productAttributes = $("#productAttributeDetails");
                $productAttributes.html(data);
                $productAttributes.html($productAttributes.find(".productDetailsAttributesWrapper"))
                ACC.customarticlecode.bindAll();
                KMVP.tooltips.bindTooltips($productAttributes);
            }
        )
        .fail(ACC.product.ajaxErrorHandler);
    },

    callVariant: function() {
        var productUrl = $('#productVariants').data('productVariantUrl');
        var productData = $('#productVariants').data('productData');
        productData.sawingLength = $('.input-miter-length').val();

        $.ajax({
            async: false,
            type: "POST",
            dataType: 'json',
            contentType: 'application/json',
            url: productUrl,
            data: JSON.stringify(productData),
            error: function (data, status) {
            },
            success: function (data) {
                if (data.variantCode != null) {
                    document.getElementById("variantCode").innerHTML = data.variantCode;
                    document.getElementById("productCodePost").value = data.variantCode;
                    $(".customerProductsForm").attr("action", "${customerproductUrl}" + data.variantCode);
                    $('.js-select-variant-hint').addClass("hide");
                } else {
                    // delete the product variant code because a variant can not be found
                    document.getElementById("productCodePost").value = "";
                    // delete the quantity to stop triggering the call to /quantitySelect becasue we do not have a real variant code
                    $('.js-quantity-value').val("");
                    $('.js-select-variant-hint').removeClass("hide");
                }

                ACC.productDetail.updateDeliveryTime(data.deliveryTime);
                ACC.productDetail.updateAvailability(data.availability);
                ACC.productDetail.updateStockAvailability(data.stockAvailability);
                ACC.productDetail.setStateClass();
                ACC.productDetail.isVariant();
                ACC.productDetail.checkDimensions();
            }
        })
    }
}

$(document).ready(function() {
    if ($('.site-kloeckner-ch, .site-kloeckner-ch-preview').length) {
        ACC.dkgProcessing.bind();
    }
});
